<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row>
        <v-col md="12">
          <span class="display-1 titulo font-weight-bold">
            Detalhes
            <span v-if="evento_nome">- {{ evento_nome }}</span>
          </span>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="12" md="9">
          <v-card flat width="100%" class="borda">
            <v-form ref="form" v-model="valid" @submit.prevent="save_evento()">
              <v-card-text>
                <v-container fluid>
                  <v-row justify="space-between">
                    <v-col cols="6" md="3">
                      <v-checkbox color="#283480" v-model="evento_status" label="Ativo"></v-checkbox>
                    </v-col>
                    <!-- <v-col cols="6" md="3">
                    <v-checkbox color="#283480" v-model="evento.unico_dia" label="Único dia"></v-checkbox>
                    </v-col>-->
                    <v-col cols="6" md="3">
                      <v-checkbox color="#283480" v-model="evento_tipo" label="Aberto ao público"></v-checkbox>
                    </v-col>
                    <v-col cols="6" md="4">
                      <v-checkbox
                        color="#283480"
                        v-model="evento_venda_ingresso"
                        label="Venda de ingresso"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" md="2">
                      <v-checkbox
                        color="#283480"
                        v-model="evento_gratis"
                        label="Grátis"
                        @change="changeGratis()"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="6">
                      <span class="font-weight-bold black--text">
                        Categoria
                        <span v-if="!evento_gratis">*</span>
                      </span>
                      <v-select
                        :items="categoriasReceita"
                        :menu-props="{ maxHeight: '200', offsetY: true, }"
                        clearable
                        v-model="novo_evento.fk_id_categoria"
                        solo
                        :rules="requiredRulesGratis"
                        :required="!evento_gratis"
                        dense
                        no-data-text="Não há categorias"
                        label="Selecione"
                        flat
                        outlined
                        @change="changeCategoria()"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <span class="font-weight-bold black--text">Categoria do Evento *</span>
                      <v-select
                        :items="categorias"
                        :menu-props="{ maxHeight: '200', offsetY: true, }"
                        clearable
                        v-model="novo_evento.fk_id_evento_categoria"
                        solo
                        :rules="requiredRules"
                        dense
                        no-data-text="Não há categorias"
                        label="Selecione"
                        flat
                        outlined
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col cols="12" sm="12" md="6">
                      <span class="font-weight-bold black--text">
                        Conta
                        <span v-if="!evento_gratis">*</span>
                      </span>
                      <v-select
                        :items="contas"
                        :menu-props="{ maxHeight: '200', offsetY: true, }"
                        clearable
                        v-model="novo_evento.fk_id_conta"
                        solo
                        :rules="requiredRulesGratis"
                        :required="!evento_gratis"
                        dense
                        no-data-text="Não há contas"
                        label="Selecione"
                        flat
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span class="font-weight-bold black--text">Imagem principal</span>
                      <v-file-input
                        prepend-icon="mdi-camera"
                        solo
                        v-model="novo_evento.evento_imagem"
                        outlined
                        accept="image/jpg, image/png, image/jpeg"
                        flat
                        dense
                      ></v-file-input>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col>
                      <span class="font-weight-bold black--text">Título*</span>
                      <v-text-field
                        label="Ex: Encerramento 2020"
                        dense
                        :rules="requiredRules"
                        v-model="novo_evento.evento_nome"
                        solo
                        flat
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="mt-n6">
                    <v-col cols="12" sm="12" md="6">
                      <span class="font-weight-bold black--text">Início *</span>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            solo
                            :rules="requiredRules"
                            flat
                            outlined
                            dense
                            @blur="novo_evento.evento_data_inicio = parseDate(dateFormatted)"
                            v-model="dateFormatted"
                            append-icon="mdi-calendar"
                            clearable
                            v-mask="data_mask"
                            v-on="on"
                            @input="menu1 = false"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date"
                          :rules="requiredRules"
                          no-title
                          locale="pt-br"
                          @input="menu1 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <span class="font-weight-bold black--text">Horário de início *</span>
                      <v-menu
                        v-model="menu3"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            solo
                            flat
                            outlined
                            :rules="requiredRules"
                            dense
                            v-model="horario_inicio"
                            append-icon="mdi-clock"
                            clearable
                            v-mask="time_mask"
                            v-on="on"
                            @input="menu3 = false"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          format="24hr"
                          v-model="horario_inicio"
                          locale="pt-br"
                          @input="menu3 = false"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col cols="12" md="6">
                      <span class="font-weight-bold black--text">Fim *</span>
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            solo
                            :rules="requiredRules"
                            flat
                            outlined
                            dense
                            @blur="novo_evento.evento_data_fim = parseDate(dateFormatted2)"
                            v-model="dateFormatted2"
                            append-icon="mdi-calendar"
                            clearable
                            v-mask="data_mask"
                            v-on="on"
                            @input="menu2 = false"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date2"
                          no-title
                          locale="pt-br"
                          @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6">
                      <span class="font-weight-bold black--text">Horário de término *</span>
                      <v-menu
                        v-model="menu4"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            solo
                            flat
                            outlined
                            dense
                            v-model="horario_fim"
                            append-icon="mdi-clock"
                            clearable
                            :rules="requiredRules"
                            v-mask="time_mask"
                            v-on="on"
                            @input="menu4 = false"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          format="24hr"
                          v-model="horario_fim"
                          locale="pt-br"
                          @input="menu4 = false"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col>
                      <span class="font-weight-bold black--text">Local *</span>
                      <v-text-field
                        label="Ex: Clube Menu Fest"
                        v-model="novo_evento.evento_local"
                        dense
                        solo
                        flat
                        :rules="requiredRules"
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n6">
                    <v-col cols="12" sm="12" md="12">
                      <span class="font-weight-bold black--text">Descrição *</span>
                      <vue-editor
                        class="tooltipDescricao"
                        v-model="novo_evento.evento_descricao"
                        :editorToolbar="editor.customToolbar"
                      ></vue-editor>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n1">
                    <v-col md="6">
                      <span class="font-weight-bold black--text">Número de participantes esperados *</span>
                      <v-text-field
                        v-model="novo_evento.evento_participantes"
                        dense
                        :rules="requiredRules"
                        solo
                        flat
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <span class="font-weight-bold black--text">Total de participantes do evento</span>
                      <v-text-field
                        v-model="novo_evento.evento_participantes_fixo"
                        dense
                        solo
                        flat
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-row class="mb-4 mt-n12" no-gutters justify="center">
                  <v-btn
                    rounded
                    color="#283480"
                    :disabled="loading_btn"
                    class="mr-2"
                    outlined
                    @click="dialog_certeza = true"
                  >Recomeçar</v-btn>
                  <v-btn
                    class="ml-2"
                    style="background-color: #283480  !important; color:#00FFD4  !important"
                    rounded
                    :disabled="loading_btn"
                    :loading="loading_btn"
                    @click="save_evento()"
                  >
                    <v-icon>mdi-content-save</v-icon>
                    <span>Salvar</span>
                  </v-btn>
                </v-row>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>

        <v-col cols="12" sm="12" md="3">
          <v-row>
            <v-card flat width="100%" height="100%" class="mr-4 borda">
              <v-col class="mr-8">
                <v-btn
                  large
                  rounded
                  block
                  style="background-color: #283480  !important;"
                  to="/eventos"
                >
                  <v-icon class="agua mr-1">mdi-arrow-left</v-icon>
                  <span class="white--text">Eventos</span>
                </v-btn>

                <v-tooltip :disabled="evento_venda_ingresso != false" top>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn
                        large
                        :to="'/eventos/detalhes/ingressos/'+ evento_id"
                        rounded
                        block
                        :disabled="disabled_ingressos_vendas"
                        class="mt-7"
                        color="#283480"
                      >
                        <v-icon class="mr-1 agua">mdi-ticket-confirmation-outline</v-icon>
                        <span class="white--text">Ingressos</span>
                      </v-btn>
                    </div>
                  </template>
                  <span>Venda de ingressos desativada</span>
                </v-tooltip>
                <v-btn
                  large
                  rounded
                  block
                  :disabled="disabled_atividades"
                  class="mt-7"
                  color="#283480"
                  :to="'/eventos/detalhes/atividades/'+ evento_id"
                >
                  <v-icon class="agua mr-1">mdi-notebook-outline</v-icon>
                  <span class="white--text">Atividades</span>
                </v-btn>

                <v-tooltip :disabled="evento_venda_ingresso != false" bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn
                        large
                        :disabled="disabled_ingressos_vendas"
                        rounded
                        :to="'/eventos/detalhes/vendas/'+ evento_id"
                        block
                        class="mt-7"
                        color="#283480"
                      >
                        <v-icon class="mr-1 agua">mdi-calendar-outline</v-icon>
                        <span class="white--text">Vendas</span>
                      </v-btn>
                    </div>
                  </template>
                  <span>Venda de ingressos desativada</span>
                </v-tooltip>
                <v-btn
                  large
                  rounded
                  block
                  :disabled="disabled_atividades"
                  class="mt-7"
                  color="#283480"
                  :to="'/eventos/detalhes/imagens/'+ evento_id"
                >
                  <v-icon class="agua mr-1">mdi-image-outline</v-icon>
                  <span class="white--text">Imagens</span>
                </v-btn>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog_certeza" persistent max-width="450">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja recomeçar o formulário?</v-card-title>
        <v-card-text>Se recomeçar perderá todos os dados informados!!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_certeza = false">Não</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            @click="close()"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG EXCLUIR PARTICIPANTE -->
    <v-dialog v-model="dialog_delete" max-width="310">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este item?</v-card-title>
        <v-card-text>Se deletar este item ele não poderá ser recuperado!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  data: () => {
    return {
      editor: {
        customToolbar: [
          ["bold", "italic"],
          [{ header: [false, 1, 2, 3, 4, 5] }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "video"],
          ["clean"]
        ],
        style: "font-size:12px!important"
        // content: this.value
      },
      dialog_certeza: false,
      disabled_atividades: true,
      disabled_ingressos_vendas: true,
      requiredRules: [v => !!v || "Campo Obrigatório."],
      horario_inicio: "",
      loading_btn: false,
      horario_fim: "",
      select_tipo_evento: [
        { text: "Aberto ao Público", value: 1 },
        { text: "Restrito à associados", value: 2 }
      ],
      valid: true,
      menu3: false,
      menu4: false,
      dialog_evento: false,
      date: "",
      dateFormatted: "",
      date2: "",
      dateFormatted2: "",
      date5: "",
      dateFormatted5: "",
      data_mask: "##/##/####",
      time_mask: "##:##",
      novo_evento: {
        evento_tipo: true,
        evento_status: true,
        evento_venda_ingresso: true,
        evento_gratis: false,
        evento_nome: "",
        evento_data_inicio: "",
        evento_data_fim: "",
        evento_local: "",
        evento_descricao: "",
        evento_participantes: 1,
        evento_participantes_fixo: 1,
        evento_imagem: null,
        fk_id_evento_categoria: null,
        fk_id_conta: null,
        fk_id_categoria: null
      },
      evento_tipo: true,
      evento_status: true,
      evento_venda_ingresso: true,
      evento_gratis: false,
      evento_nome: "",
      evento_id: null,
      categorias: [],
      categoriasReceita: [],
      contas: [],
      menu1: false,
      menu2: false,
      menu5: false,
      dialog_delete: false,
      search: "",
      requiredRulesGratis: [v => !!v || "Campo Obrigatório."]
    };
  },
  mounted() {
    this.getCategorias();
    this.getCategoriasReceita();
    this.getContas();
    if (this.$route.params.id == 0) {
      console.log();
    } else {
      this.getEvento();
      this.evento_id = this.$route.params.id;
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    computedDateFormatted2() {
      return this.formatDate(this.date2);
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
      this.novo_evento.evento_data_inicio = this.parseDate(this.dateFormatted);
    },
    date2() {
      this.dateFormatted2 = this.formatDate(this.date2);
      this.novo_evento.evento_data_fim = this.parseDate(this.dateFormatted2);
    },

    evento_venda_ingresso() {
      if (this.evento_venda_ingresso == true && this.evento_id) {
        this.disabled_ingressos_vendas = false;
      } else {
        this.disabled_ingressos_vendas = true;
      }
    }
  },
  methods: {
    close() {
      this.novo_evento = {
        evento_nome: "",
        evento_data_inicio: "",
        evento_data_fim: "",
        evento_local: "",
        evento_descricao: "",
        evento_participantes: 1,
        evento_participantes_fixo: 1,
        fk_id_evento_categoria: "",
        fk_id_conta: "",
        fk_id_categoria: ""
      };
      this.date = "";
      this.date2 = "";
      this.horario_inicio = "";
      this.horario_fim = "";
      this.dialog_certeza = false;
      (this.evento_tipo = true),
        (this.evento_status = true),
        (this.evento_venda_ingresso = true),
        (this.evento_gratis = false),
        this.$refs.form.resetValidation();
    },
    getEvento() {
      Api.get("/eventos/show/" + this.$route.params.id)
        .then(response => {
          if (!response.data.errors) {
            let item = response.data[0];
            this.novo_evento = {
              evento_nome: item.evento_nome,
              evento_data_inicio: item.evento_data_inicio.substr(0, 10),
              evento_data_fim: item.evento_data_fim.substr(0, 10),
              evento_local: item.evento_local,
              evento_descricao: item.evento_descricao,
              evento_participantes: item.evento_participantes,
              evento_participantes_fixo: item.evento_participantes_fixo,
              fk_id_evento_categoria: item.fk_id_evento_categoria,
              fk_id_conta: item.fk_id_conta,
              fk_id_categoria: item.fk_id_categoria
            };
            this.evento_nome = item.evento_nome;
            this.disabled_atividades = false;
            this.date = item.evento_data_inicio.substr(0, 10);
            this.date2 = item.evento_data_fim.substr(0, 10);
            this.horario_inicio = item.evento_data_inicio.substr(11, 5);
            this.horario_fim = item.evento_data_fim.substr(11, 5);
            if (item.evento_status == 1) {
              this.evento_status = true;
            } else {
              this.evento_status = false;
            }
            if (item.evento_venda_ingresso == 1) {
              this.evento_venda_ingresso = true;
            } else {
              this.evento_venda_ingresso = false;
            }
            if (item.evento_tipo == 1) {
              this.evento_tipo = true;
            } else {
              this.evento_tipo = false;
            }
            if (this.evento_venda_ingresso == true) {
              this.disabled_ingressos_vendas = false;
            }
            if (item.evento_gratis == 1) {
              this.evento_gratis = true;
            } else {
              this.evento_gratis = false;
            }
            this.changeGratis();
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error("Evento não encontrado ou sem permissão!");

          setTimeout(() => {
            this.$toast.default("Redirecionando para Eventos!");
          }, 1400);

          setTimeout(() => {
            this.$router.push({ name: "Eventos" });
          }, 5000);
          throw err;
        });
    },

    save_evento() {
      if (this.$refs.form.validate()) {
        this.loading_btn = true;
        this.novo_evento.evento_data_inicio =
          this.novo_evento.evento_data_inicio + " " + this.horario_inicio;
        this.novo_evento.evento_data_fim =
          this.novo_evento.evento_data_fim + " " + this.horario_fim;

        if (this.evento_venda_ingresso) {
          this.novo_evento.evento_venda_ingresso = 1;
        } else {
          this.novo_evento.evento_venda_ingresso = 0;
        }

        if (this.evento_status) {
          this.novo_evento.evento_status = 1;
        } else {
          this.novo_evento.evento_status = 0;
        }
        if (this.evento_tipo) {
          this.novo_evento.evento_tipo = 1;
        } else {
          this.novo_evento.evento_tipo = 0;
        }
        if (this.evento_gratis) {
          this.novo_evento.evento_gratis = 1;
        } else {
          this.novo_evento.evento_gratis = 0;
        }

        if (this.novo_evento.fk_id_conta == undefined) {
          this.novo_evento.fk_id_conta = "";
        }

        let clubeAtual = JSON.parse(localStorage.getItem("clube-atual"));

        this.novo_evento.fk_id_clube = clubeAtual.id_clube;

        let formData = new FormData();
        Object.keys(this.novo_evento).map(key => {
          if (key === "evento_imagem") {
            let file = this.novo_evento.evento_imagem;
            if (this.novo_evento.evento_imagem) {
              if (this.novo_evento.evento_imagem.name) {
                formData.append(
                  `evento_imagem`,
                  file,
                  `${new Date().getTime()}.${this.getExtension(
                    this.novo_evento.evento_imagem.name
                  )}`
                );
              }
            }
          } else {
            if (this.novo_evento[key] !== null) {
              formData.append(key, this.novo_evento[key]);
            }
          }
        });
        let edit = "";
        if (this.$route.params.id != 0) {
          edit = "/update/" + this.$route.params.id;
        } else {
          edit = "/store/";
          
        }

        Api.post("/eventos" + edit, formData)
          .then(response => {
            if (!response.data.errors) {
              if (this.$route.params.id != 0) {
                this.$toast.success("Evento atualizado com sucesso!");
                this.evento_id = this.$route.params.id;
              } else {
                this.$toast.success("Evento cadastrado com sucesso!");
                this.evento_id = response.data.id_evento;
              }
            } else {
              this.$toast.warning(response.data.errors);
            }
            if (this.$route.params.id == 0) {
              this.$router.push({
                path: "/eventos/detalhes/" + this.evento_id
              });
              setTimeout(() => location.reload(), 1000);
              this.$vuetify.goTo(0);
              this.loading_btn = false;
            } else {
              this.$vuetify.goTo(0);
              this.loading_btn = false;
            }
            this.loading_btn = false;

            this.evento_nome = this.novo_evento.evento_nome;
            this.disabled_atividades = false;
            if (this.evento_venda_ingresso == true) {
              this.disabled_ingressos_vendas = false;
            }
          })
          .catch(err => {
            this.loading_btn = false;
            if (err.response.errors) {
              this.$toast.error(err.response.errors);
            } else {
              this.$toast.error(
                "Oops, verifique os dados informados para o Evento"
              );
            }
            throw err;
          });
        this.novo_evento.evento_data_inicio = this.novo_evento.evento_data_inicio.substr(
          0,
          10
        );
        this.novo_evento.evento_data_fim = this.novo_evento.evento_data_fim.substr(
          0,
          10
        );
      }
    },
    getCategorias() {
      Api.get("/eventos/evento-categorias")
        .then(response => {
          if (!response.data.errors) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.categorias.push({
                text: response.data.data[i].evento_categoria_nome,
                value: response.data.data[i].id_evento_categoria
              });
            }
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    getCategoriasReceita() {
      Api.get("/eventos/categorias-lancamentos?tipo=1")
        .then(response => {
          if (!response.data.errors) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.categoriasReceita.push({
                text: response.data.data[i].categoria_nome,
                value: response.data.data[i].id_categoria
              });
            }
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },

    getContas() {
      Api.get("/eventos/contas")
        .then(response => {
          if (!response.data.errors) {
            for (let i = 0; i < response.data.data.length; i++) {
              this.contas.push({
                text: response.data.data[i].conta_nome,
                value: response.data.data[i].id_conta
              });
            }
          } else {
            this.$toast.warning(response.data.errors);
          }
        })
        .catch(err => {
          this.$toast.error(err.response.data.errors);
          throw err;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    getExtension(path) {
      var basename = path.split(/[\\/]/).pop(),
        pos = basename.lastIndexOf(".");

      if (basename === "" || pos < 1) return "";

      return basename.slice(pos + 1);
    },

    changeGratis() {
      if (!this.evento_gratis) {
        this.requiredRulesGratis = [v => !!v || "Campo Obrigatório."];
      } else {
        this.requiredRulesGratis = [];
      }
    },

    changeCategoria() {
      if (!this.novo_evento.fk_id_categoria) {
        this.novo_evento.fk_id_categoria = "";
      }
    }
  }
};
</script>

<style>
.ql-snow .ql-tooltip {
  transform: translateY(10px) !important;
  background-color: #fff !important;
  border: 1px solid #ccc !important;
  box-shadow: 0 0 5px #ddd !important;
  color: #444 !important;
  padding: 5px 12px !important;
  white-space: nowrap !important;
  position: unset !important;
}
</style>